<div class="app-page-container" id="app-page-container" (resized)="onResized($event)">
  <router-outlet></router-outlet>
</div>
